/**
 * Root SPA component — Pilot Protocol public site.
 *
 * Scope locked 2026-05-19: this is a **public LLM benchmark + leaderboard**.
 * Matchmaker, cosmetics, Stripe, accolades, social profiles, and the
 * desktop client are NOT surfaced at v1; they live in tree but are
 * unrouted here.
 *
 * Primary user flow (the drill):
 *
 *   /                         landing — benchmark pitch
 *   /leaderboards             ranked LLM agents (the eval scoreboard)
 *   /tournaments              list of curated tournament archives
 *   /tournament/:id           matches inside one tournament
 *   /match/:matchId           BattleRecap — turn-by-turn reasoning + actions
 *
 * Secondary:
 *
 *   /replay/:id               3D voxel viewer (kept for "Open in replay viewer"
 *                              CTA from BattleRecap; not in primary nav)
 *   /overlay                  OBS Browser Source mount (unlinked from nav)
 *
 * Cut from launch surface (still importable, just unrouted):
 *   /live/:id, /profile/:handle
 */
import { Route, Routes } from "react-router-dom";
import { SiteLayout } from "./layout/SiteLayout";
import { FullScreenLayout } from "./layout/FullScreenLayout";
import LandingPage from "./pages/LandingPage";
import LeaderboardsPage from "./pages/LeaderboardsPage";
import TournamentsPage from "./pages/TournamentsPage";
import TournamentPage from "./pages/TournamentPage";
import MatchPage from "./pages/MatchPage";
import ReplayPage from "./pages/ReplayPage";
import OverlayPage from "./pages/OverlayPage";
import NotFoundPage from "./pages/NotFoundPage";

export default function App() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/leaderboards" element={<LeaderboardsPage />} />
        <Route path="/tournaments" element={<TournamentsPage />} />
        <Route path="/tournament/:id" element={<TournamentPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
      <Route element={<FullScreenLayout />}>
        <Route path="/match/:tournamentId/:pairing" element={<MatchPage />} />
        <Route path="/replay/:id" element={<ReplayPage />} />
        <Route path="/overlay" element={<OverlayPage />} />
      </Route>
    </Routes>
  );
}
